import Bs4File from './Bs4File'

export default class Bs41File extends Bs4File {

  fileLimit = 1;
}